export interface DataEntry {
  key: string;
  value: string;
  href: string | null;
}

function isHttpUrl(v: unknown): v is string {
  return typeof v === "string" && /^https?:\/\//.test(v);
}

/** Flatten an event's `data` JSONB into displayable rows, linkifying URL values. */
export function dataEntries(data: Record<string, unknown> | null | undefined): DataEntry[] {
  if (data === null || data === undefined) return [];
  return Object.entries(data).map(([key, raw]) => ({
    key,
    value: typeof raw === "string" ? raw : JSON.stringify(raw),
    href: isHttpUrl(raw) ? raw : null
  }));
}
